import { AUTHLinks } from '~/layout/Auth/models';
import { linkBaseMapper } from '~/mappers/link';

import { AuthLinksType } from './models';

export const authLinkMapper = (auth: AUTHLinks): AuthLinksType => ({
  loginLinkHref: linkBaseMapper(auth.loginLink).href,
  profileLinkHref: linkBaseMapper(auth.profileLink).href,
  registerLinkHref: linkBaseMapper(auth.registerLink).href,
  loginSuccessLinkHref: linkBaseMapper(auth.loginSuccessLink).href,
  registerSuccessLinkHref: linkBaseMapper(auth.registerSuccessLink).href,
  passwordSuccessLinkHref: linkBaseMapper(auth.resetPasswordSuccessLink).href,
  forgotPasswordLinkHref: linkBaseMapper(auth.forgotPasswordLink).href,
});
